import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import { imageError } from '../utils/imageError';
import { DataStore } from '../stores';
import Icon from './Icon';

const ImageContainer = styled<any, any>('div')`
    ${propStyles};
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
`;

ImageContainer.defaultProps = {
    alignSelf: 'center',
    display: 'block',
    height: ['80px', '120px'],
    width: ['80px', '120px'],
    marginY: ['sm', '0'],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'gray300',
    borderRadius: '120px',
    bgColor: 'gray100',
};

const Image = styled<any, any>('img')`
    ${propStyles};
    position: relative;
    z-index: 1;
    overflow: hidden;
    text-indent: -100em; /* hides alt text */
`;

Image.defaultProps = {
    display: 'block',
    width: '100%',
};

interface FundManagerImage {
    theme?: any;
    dataStore?: DataStore;
    name: string;
    code: string;
    src?: string;
}

@inject('dataStore')
@observer
class FundManagerImage extends Component<FundManagerImage> {
    constructor(props) {
        super(props);
    }

    render() {
        const { theme, dataStore, name, code, src } = this.props;
        const imgSrc = src
            ? src
            : `${dataStore.baseUrl}/fund/fundmanagerpicture?code=${code}&token=${dataStore.token}`;

        return (
            <ImageContainer {...theme.FundManagerImage}>
                <Image
                    src={imgSrc}
                    alt={name}
                    onError={e => imageError(e.target)}
                />
                <Icon
                    fileName="FundManagerPlaceholder"
                    display="block"
                    height="100%"
                    width="100%"
                    {...theme.FundManagerPlaceholderImage}
                />
            </ImageContainer>
        );
    }
}

export default withTheme(FundManagerImage);



// WEBPACK FOOTER //
// ./src/Components/FundManagerImage.tsx